<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class='h100vh-100'>
        <div class="h-toolbarBg">
          <ejs-toolbar>
            <e-items>
              <e-item prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("System.addPkg")' :click="addDialog"></e-item>
              <e-item prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("System.delete")' :click="delDialog"></e-item>
              <e-item prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Alarm.refresh")' :click="getAdapterTree"></e-item>
            </e-items>
          </ejs-toolbar>
          <div class="h-inputBox">
            <input class="e-input" :placeholder='$t("System.inputTip7")' @keyup.enter="filterData" v-model="keyString" maxLength='15' />
          </div>
        </div>
        <div class="h100-40 noPage">
          <ejs-treegrid ref="grid" height='calc(100vh - 180px)' childMapping="children" :treeColumnIndex="1" :autoCheckHierarchy="true" :collapsed="true" :rowDataBound="rowDataBound" :enableCollapseAll="true">
            <e-columns>
              <e-column field="productName" :headerText='$t("System.productType")' width="70" :showCheckbox="true"></e-column>
              <e-column field="neType" :headerText='$t("System.productEle")' width="200" textAlign="Left"></e-column>
              <e-column field="displayVersionShow" :headerText='$t("System.productVersion")' width="90" textAlign="Left"></e-column>
              <e-column field="updateTimeString" :headerText='$t("System.changeTime")' width="90" textAlign="Middle"></e-column>
            </e-columns>
          </ejs-treegrid>
        </div>
      </div>
      <div class="h-system-hide-upload">
        <ejs-uploader ref="file" name="file" id="file" autoUpload="false" :selected="onFileSelect" allowedExtensions=".zip" :multiple="false"></ejs-uploader>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from "../../layouts/BasicLayout";
import CustomDialog from "../../components/common/CustomDialog";

export default {
  name: "AdapterPkg",
  props: {
    user: String
  },
  data() {
    return {
      left: { show: false, name: '' },
      middle: { show: false, name: "" },
      right: { show: true, crumb: `${this.$t('System.systemManager')}/${this.$t('System.pkgManager')}` },
      systemId: 1,
      keyString: "",
      userName: this.user,
      neMap: {
        0: this.$t('System.neOAM'),
        3: this.$t('Topo.neMME'),
        4: this.$t('Topo.neHSS'),
        5: this.$t('Topo.nePGW'),
        6: this.$t('Topo.neSGW'),
        7: this.$t('Topo.nePCRF'),
        8: this.$t('Topo.neTCF'),
        9: this.$t('Topo.neTMF'),
        10: this.$t('Topo.nePDTGW'),
        11: this.$t('Topo.neDBS'),
        12: this.$t('Topo.neMC_CMS'),
        13: this.$t('Topo.neMC_CF'),
        14: this.$t('Topo.neMC_GMS'),
        15: this.$t('Topo.neMC_IDMS'),
        16: this.$t('Topo.neMC_PF'),
        17: this.$t('Topo.neBM_SC'),
        18: this.$t('Topo.neMBMS_GW'),
        19: this.$t('Topo.neFRS'),
        20: this.$t('Topo.neMC_TMF'),
        21: this.$t('Topo.nePRES'),
        23: this.$t('Topo.neP_HSS'),
        24: this.$t('Topo.neMC_KMS'),
        27: this.$t('Topo.neMCE'),
        28: this.$t('Topo.nePCDR'),
        31: this.$t('Topo.neDMS'),
        34: this.$t('Topo.neMC_GMS_NODE'),
        35: this.$t('Topo.neCU'),
        36: this.$t('Topo.neDU'),
        10001: this.$t('System.epcOAM'),
        10002: this.$t('System.imsOAM'),
        10003: this.$t('System.mcsOAM'),
        10004: this.$t('System.enodeb'),
		10006: this.$t('Topo.deviBS'),
        10007: this.$t('System.ibs_b'),
        10010: this.$t('System.ims_hytalk'),
        20001: this.$t('System.mcscl')
      },
      constData: []
    }
  },
  components: {
    BasicLayout,
    CustomDialog
  },
  methods: {
    filterData(){
      if (this.constData == null) {
        return null;
      }
      let filterData = [];
      this.constData.forEach(e => {
        if (
          e.productName.indexOf(this.keyString) != -1 ||
          e.neType.indexOf(this.keyString) != -1 ||
          e.displayVersionShow.indexOf(this.keyString) != -1
        ) {
          filterData.push(e);
        }
      });
      this.$refs.grid.ej2Instances.dataSource = filterData;
    },
    getAdapterTree() {
      const url = "/lte/ems/sysmanager/vpmgr/getdatatree";
      let params = { systemId: this.systemId, keyString: this.keyString };
      this.axios.get(url, { params }).then(response => {
        let result = response.data.result;
        if (result == null || result == "") {
          this.$refs.grid.ej2Instances.dataSource = result;
          return null;
        }
        let showRe = [];
        let parent = new Boolean();
        result.forEach(item => {
          parent = true;
          let re = {};
          re.productName = item.productName;
          re.oamTypeCode = item.oamTypeCode;
          // TODO 国际化翻译
          re.neType = this.neMap[item.oamTypeCode];
          // 多版本号特殊处理
          let displayversion = item.displayversion;
          if(displayversion.split('_').length > 2){
            const ix = this.findStrIndex(displayversion, '_', 1) + 1;
            displayversion = displayversion.substring(ix, displayversion.length);
          }
          re.displayVersion = item.displayversion
          re.displayVersionShow = displayversion;
          re.updateTimeString = item.updateTimeString;
          re.inVersion = item.inversion;
          re.outVersion = item.outversion;
          re.children = [];
          showRe.forEach(e => {
            if (e.inVersion === re.inVersion) {
              e.displayVersionShow = e.inVersion;
              e.neType += ',' + this.neMap[item.oamTypeCode];
              e.children.push(re);
              parent = false;
            }
          });
          if (parent) {
            re.children.push(this.copyDeep(re));
            showRe.push(re);
          }
        });
        showRe.forEach(item => {
          if (item.children.length < 2) {
            item.children.length = 0;
          }
        });
        this.constData = showRe;
        this.$refs.grid.ej2Instances.dataSource = showRe;
      });
    },
    findStrIndex(str, cha, num) {
      var x = str.indexOf(cha);
      for (var i = 0; i < num; i++) {
        x = str.indexOf(cha, x + 1);
      }
      return x;
    },
    addDialog() {
      document
        .getElementsByClassName("e-file-select-wrap")[0]
        .querySelector("button")
        .click();
      return false;
    },
    delDialog() {
      let selectedData = this.$refs.grid.ej2Instances.getCheckedRecords();
      if (selectedData == null || selectedData.length === 0) {
        this.$parent.showToast('warning',`${this.$t("System.selectDelObj")}`);
        return null;
      }
      this.$layer.confirm({
        msg: this.$t('System.delPkgTip'),
        btn1: {
          msg: this.$t('System.confirm'),
          func: this.delAdapter
        }
      });
    },
    addAdapter() {
      const url = "/lte/ems/sysmanager/vpmgr/upload";
      let formData = new FormData();
      let uploadFile = document.getElementById("file").files[0];
      formData.append("userName", this.userName);
      formData.append("file", uploadFile);
      const config = {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        timeout: 60 * 6 * 1000
      };
      this.$loading.showLoadding(this.$t('System.uploadFile'), uploadFile.name);
      this.axios.post(url, formData, config).then(response => {
        if (response['data'].errorCode == 'SUCCESS') {
          this.$parent.showToast('success',`${this.$t("Common.tips.success")}`);
        } else {
          this.$parent.showToast('error',response['data'].errorString);
        } 
        this.$loading.hideLoadding();
        this.getAdapterTree();
        // 解决组件添加相同文件不触发onFileSelect bug
        const element = document.getElementsByClassName('e-file-remove-btn')[0];
        element.click();
      });      
    },
    delAdapter() {
      const url = "/lte/ems/sysmanager/vpmgr/branchdelete";
      const selectedData = this.$refs.grid.ej2Instances.getCheckedRecords();
      const params = [];
      selectedData.forEach(item => {
        params.push({
          productName: item.productName,
          oamTypeCode: item.oamTypeCode,
          outversion: item.outVersion,
          displayversion: item.displayVersion,
          inversion: item.inVersion,
          userName: this.userName
        });
      });
      this.$loading.showLoadding(this.$t('System.deleteFile'), '');
      this.$axios.post(url, params, { timeout: 60 * 6 * 1000 }).then(response => {
        this.$loading.hideLoadding();
        if (response['data'].errorCode == 'SUCCESS') {
          this.$parent.showToast('success',`${this.$t("Common.tips.success")}`);
        } else {
          this.$parent.showToast('error',response['data'].errorString);
        }
        this.getAdapterTree();
      });
    },
    onFileSelect(args) {
      const file = args.filesData;
      if (file[0].name.indexOf('.zip') == -1) {
        this.$parent.showToast('warning',`${this.$t("System.zipTip")}`);
        return null;
      }
      this.addAdapter();
    },
    copyDeep(data) {
      let returnData = JSON.parse(JSON.stringify(data));
      return returnData;
    },
    rowDataBound(args) {
      // 只允许整包删除适配包，treegrid 子args.data['level'] = 1
      if (args.data['level'] === 1) {
        args.row.getElementsByClassName('e-checkbox-wrapper')[0].classList.add('h-system-disablecheckbox')
      }
    }
  },
  mounted() {
    this.getAdapterTree();
  }
};
</script>